import React, { useState, useEffect } from 'react'
import Button from '@react/react-spectrum/Button'
import Select from '@react/react-spectrum/Select'
import { StepList, Step } from '@react/react-spectrum/StepList'
import Heading from '@react/react-spectrum/Heading'
import { success } from '@react/react-spectrum/Toast'

import './LogCall.scss'

const initSelectDetails = [
  {
    name: 'callTopic',
    label: 'Call Topic',
    items: [
      { label: 'Wifi Issues', value: 'wifi' },
      { label: 'Promotion', value: 'promo' },
      { label: 'Invoice Questions', value: 'invoice' },
      { label: 'Complaint', value: 'complaint' },
      { label: 'Contract Discussion', value: 'contract' },
    ],
  },
  {
    name: 'callFeeling',
    label: 'Call Feeling',
    items: [
      { label: 'Positive', value: 'positive' },
      { label: 'Neutral', value: 'neutral' },
      { label: 'Negative', value: 'negative' },
    ],
  },
]

const contractDetails = {
  name: 'contractCancelled',
  label: 'Contract Cancelled',
  items: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ],
}

export default function LogCall({ evtName }) {
  const [state, setState] = useState({
    step: 0,
    disabled: true,
    callTopic: '',
    callFeeling: '',
    contractCancelled: false,
    churnScore: 0,
  })

  const [selectDetails, setSelectDetails] = useState(initSelectDetails)

  const handleChange = (e, name) => {
    if (name === 'callTopic') {
      if (e === 'contract') {
        setSelectDetails([...initSelectDetails, contractDetails])
      } else {
        setSelectDetails(initSelectDetails)
      }
      setState({ ...state, step: 1, [name]: e })
    } else if (name === 'callFeeling') {
      setState({
        ...state,
        step: state.callTopic !== 'contract' ? 1 : 2,
        [name]: e,
        disabled: e !== 'contract' ? false : true,
      })
    } else if (name === 'contractCancelled') {
      setState({ ...state, [name]: e, disabled: false })
    }
  }

  const handleStep = (e) => {
    setState({ ...state, step: e })
  }

  const handleClick = (e) => {
    if (state.callTopic === 'contract' && state.contractCancelled === 'yes') {
      state.churnScore = 100
    } else if (state.callFeeling === 'positive') {
      state.churnScore = 15
    } else if (state.callFeeling === 'neutral') {
      state.churnScore = 37
    } else {
      state.churnScore = 78
    }

    e.target.dispatchEvent(
      new CustomEvent(evtName, {
        detail: {
          callContractCancelled: state.contractCancelled === 'yes' ? true : false,
          callFeeling: state.callFeeling,
          callTopic: state.callTopic,
          callSatisfaction: state.churnScore,
        },
      })
    )
    success('Call Details Submitted', {
      onClose: {},
      timeout: 4000,
    })
  }

  return (
    <>
      <Heading size={5} className='heading'>
        Log Call Details
      </Heading>
      <StepList size='L' selectedIndex={state.step} onChange={(e) => handleStep(e)}>
        {selectDetails.map((s, idx) => {
          return <Step key={idx}>{s.label}</Step>
        })}
      </StepList>

      <div className='log-call'>
        <div className='container container-1' style={{ display: 'visible' }}>
          <Select
            required
            aria-label={selectDetails[state.step].name}
            onChange={(e) => handleChange(e, selectDetails[state.step].name)}
            options={selectDetails[state.step].items}
          />
        </div>
      </div>
      <div className='logButton'>
        <Button variant='primary' name='submitChurn' disabled={state.disabled ? true : false} onClick={handleClick}>
          Submit
        </Button>
      </div>
    </>
  )
}
